import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href", "target"];
const _hoisted_2 = ["alt", "src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("a", {
    href: $options.logoHref,
    target: $props.target,
    class: _normalizeClass(_ctx.logo - _ctx.link)
  }, [_createElementVNode("img", {
    class: _normalizeClass($options.logoClasses),
    alt: $props.alt,
    src: $options.logoUrl
  }, null, 10, _hoisted_2)], 10, _hoisted_1);
}